export default __webpack_public_path__ + "assets/images/mbrArGraph-a6522a38da9bef1d902809a19959ac11.png";